import { useEffect, useRef } from "react";
import log from "src/helpers/log";
import useAudioPlayerStore from "src/stores/useAudioPlayerStore";

const LazyAudioPlayerInternal = ({ audioUrl }: { audioUrl: string }) => {
	const audioRef = useRef<HTMLAudioElement | null>(null);
	const status = useAudioPlayerStore((state) => state.status);
	const setStatus = useAudioPlayerStore((state) => state.setStatus);

	useEffect(() => {
		const audio = audioRef.current;
		if (!audio) return;

		audio.loop = true;
		if (status === "playing") {
			audio.play().catch((err) => {
				if (
					err instanceof Error &&
					(err.message.includes("not allowed") ||
						err.message.includes("can only be initiated by a user gesture"))
				) {
					setStatus("paused");
				} else {
					log.error({ err }, "Audio play error");
				}
			});
		}
		if (status === "paused") {
			audio.pause();
		}
		return () => {
			audio.pause();
		};
	}, [status, setStatus]);

	return <audio ref={audioRef} src={audioUrl} style={{ display: "none" }} />;
};
export default LazyAudioPlayerInternal;
